module.exports = __webpack_public_path__ + "static/media/oh_pack2_sample009_0001.461830dd.png";